/**
 * Binds an accordion button to toggle the visibility of its associated panel.
 * @param btn The element that was clicked
 */
const bindAccordion = (btn: HTMLElement) => {
  btn.addEventListener('click', (e)=> {
    e.preventDefault();

    const parent = btn.closest('.js-accordion-item');

    // grab panel
    const panel = parent?.querySelector<HTMLElement>('.js-accordion-panel') ??
      parent?.querySelector<HTMLElement>('.ais-Panel-body');

    if (panel?.classList.contains('open')) {
      btn.classList.remove('open');
      panel.style.maxHeight = '0';
      panel.classList.remove('open');
      panel.setAttribute('aria-hidden', 'true');
    } else if (panel) {
      btn.classList.add('open');
      panel.style.maxHeight = `${panel.scrollHeight}px`;
      panel.classList.add('open');
      panel.removeAttribute('aria-hidden');
    }
  });
};

/**
 * Bind all unbound accordions.
 * We set a data-bound attribute on the button to prevent re-binding.
 */
const bindAllUnboundAccordions = () => {
  const accordionBtns = document.querySelectorAll<HTMLElement>('.js-accordion-toggle:not([data-bound])');

  accordionBtns.forEach((btn) => {
    bindAccordion(btn);
    btn.setAttribute('data-bound', 'true');
  });
};

document.addEventListener('DOMContentLoaded', () => {
  bindAllUnboundAccordions();

  // Add handler for custom event to trigger re-binding of accordions
  // TODO: It might be better to send the accordion element to re-bind one at a time?
  document.addEventListener('accordion:add', () => {
    console.debug('Re-binding accordions');
    bindAllUnboundAccordions();
  });
});
